export default {
  redditLikeApiBaseUrl: process.env.REACT_APP_REDDITLIKE_API_BASE_URL
}
